import { createFileRoute } from "@tanstack/react-router";
import { SubmissionsTab } from "@/components/admin/SubmissionsTab";

export const Route = createFileRoute("/admin/submissions")({
  head: () => ({
    meta: [
      { title: "Submissions · Admin · INFLOW Marketing" },
      { name: "description", content: "Audit trail of every opt-in attempt and orphaned completions." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-3xl tracking-tight">Submissions</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Audit trail of every opt-in attempt and orphaned survey completions.
        </p>
      </div>
      <SubmissionsTab />
    </div>
  ),
});
